<template>
   <!-- 赠品选择弹窗 -->
   <el-dialog title="赠品选择" :visible.sync="dialogVisible" width="820px" append-to-body @close="handleClose" @opened="onGiftDialogOpened">
      <!-- 赠品信息列表 -->
      <div class="gift-list-section">
         <el-table ref="giftTable" :data="giftList" style="width: 100%" max-height="300" highlight-current-row @keydown.native="handleGiftTableKeydown" tabindex="0" @row-click="selectGiftRow">
            <el-table-column label="选择" width="30" align="center">
               <template slot-scope="scope">
                  <el-radio v-model="selectedGiftId" :label="scope.row.bgmId" @change="onGiftSelectionChange(scope.row)"></el-radio>
               </template>
            </el-table-column>
            <el-table-column label="批号" width="180">
               <template slot-scope="scope">
                  <el-input v-if="!scope.row.batchno" ref="batchInput" clearable v-model="scope.row.batchno" placeholder="请输入批号" @keyup.enter.native="openSearch(2938338312, scope.row.bgmId)">
                     <el-button @click="openSearch(2938338312, scope.row.bgmId)" slot="append" icon="el-icon-search">
                     </el-button>
                  </el-input>
                  <span v-else>{{ scope.row.batchno || '-' }}</span>
               </template>
            </el-table-column>
            <el-table-column label="商品名称" width="200">
               <template slot-scope="scope">
                  <span>{{ scope.row.bgmName }}</span>
               </template>
            </el-table-column>
            <el-table-column label="规格" width="120">
               <template slot-scope="scope">
                  <span>{{ scope.row.spec || '无' }}</span>
               </template>
            </el-table-column>
            <!-- <el-table-column label="赠送数量" width="120">
               <template slot-scope="scope">
                  <span>{{ scope.row.giftQuantity || '无' }}</span>
               </template>
            </el-table-column> -->
            <el-table-column label="库存数量" width="120">
               <template slot-scope="scope">
                  <span>{{ scope.row.num || '无' }}</span>
               </template>
            </el-table-column>
            <el-table-column label="生产厂家" width="150">
               <template slot-scope="scope">
                  <span>{{ scope.row.manufacturer || '无' }}</span>
               </template>
            </el-table-column>
            <el-table-column label="失效日期" width="150">
               <template slot-scope="scope">
                  <span>{{ $common.getLocalTime(scope.row.expidate) }}</span>
               </template>
            </el-table-column>
            <el-table-column prop="bgiPretype" label="处方类型" width="150">
               <template slot-scope="scope">
                  <span>{{ scope.row.bgiPretype }}</span>
               </template>
            </el-table-column>
            <el-table-column label="商品类型" width="150">
               <template slot-scope="scope">
                  <span>{{ scope.row.bgiType }}</span>
               </template>
            </el-table-column>
         </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
         <el-button ref="confirmButton" type="primary" @click="confirmSelection" @keydown.native="handleConfirmButtonKeydown">确定</el-button>
      </span>

      <!-- 批号选择弹窗 -->
      <el-dialog title="批号选择" :visible.sync="batchDialogVisible" width="800px" append-to-body @close="closeBatchDialog" @opened="onBatchDialogOpened">
         <el-table ref="batchTable" :data="batchList" style="width: 100%" highlight-current-row @row-click="selectBatch" @row-dblclick="confirmBatchSelection" @current-change="handleCurrentChange" max-height="400"
                   @keydown.native="handleTableKeydown">
            <el-table-column label="仓库" prop="stName" min-width="150"></el-table-column>
            <el-table-column label="批号" prop="batchno" width="120"></el-table-column>
            <el-table-column label="库存数量" prop="num" width="100">
               <template slot-scope="scope">
                  <span>{{ scope.row.num }}</span>
               </template>
            </el-table-column>

            <el-table-column label="售价" prop="psprice" width="100">
               <template slot-scope="scope">
                  <span>{{ scope.row.psprice.toFixed(2) }}</span>
               </template>
            </el-table-column>
            <el-table-column label="库存数量" width="120">
               <template slot-scope="scope">
                  <span>{{ scope.row.num || '无' }}</span>
               </template>
            </el-table-column>
            <el-table-column label="赠品数量" width="120">
               <template slot-scope="scope">
                  <el-input v-model="scope.row.giftQuantity" :min="0" :max="scope.row.num" type="number" size="mini">
                  </el-input>
               </template>
            </el-table-column>
            <el-table-column label="生产日期" prop="prodate" width="120">
               <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.prodate) }}</span>
               </template>
            </el-table-column>
            <el-table-column label="有效期" prop="expidate" width="120">
               <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.expidate) }}</span>
               </template>
            </el-table-column>
            <el-table-column prop="bgiPretype" label="处方类型" width="150">
               <template slot-scope="scope">
                  <span>{{ scope.row.bgiPretype }}</span>
               </template>
            </el-table-column>
            <el-table-column label="商品类型" prop="bgiType" width="120">
               <template slot-scope="scope">
                  <span>{{ scope.row.bgiType }}</span>
               </template>
            </el-table-column>
         </el-table>

      </el-dialog>
   </el-dialog>

</template>

<script>
export default {
   name: 'GiftSelectionDialog',
   props: {
      visible: {
         type: Boolean,
         default: false
      },
      giftInfo: {
         type: Array,
         default: () => []
      }
   },
   data() {
      return {
         inputBatchNo: '',
         giftList: [],
         DialogVisible: false,
         seId: "",
         smId: "",
         sField: "",
         seTitle: "",
         parentSearchData: {},
         // 批号选择弹窗相关
         batchDialogVisible: false,
         batchList: [],
         selectedBatch: null,
         currentRowIndex: 0,
         // 单选赠品相关
         selectedGiftId: null,
         selectedGift: null,
         // 每行独立的批号输入值
         batchInputValues: {},
         // 当前正在操作批号的商品ID
         currentBatchBgmId: null,
      };
   },
   computed: {
      dialogVisible: {
         get() {
            return this.visible;
         },
         set(val) {
            this.$emit('update:visible', val);
         }
      }
   },
   watch: {
      visible(newVal) {
         if (newVal) {
            this.initDialog();
         }
      }
   },

   methods: {
      // 获取批号输入值
      getBatchInputValue(bgmId) {
         return this.batchInputValues[bgmId] || '';
      },

      // 更新批号输入值
      updateBatchInputValue(bgmId, value) {
         this.$set(this.batchInputValues, bgmId, value);
      },

      // 打开批号搜索弹窗
      openSearch(seId, bgmId) {
         // 记住当前正在操作批号的商品ID
         this.currentBatchBgmId = bgmId;

         this.$http.querySearchPlanEntityVo({
            "searchPlanId": seId,
            "page": 1,
            "rows": 1000,
            "bgmId": bgmId
         }).then(res => {
            // 为每个批号设置默认赠品数量为0
            this.batchList = res.rows.map(batch => ({
               ...batch,
               giftQuantity: 0
            }));
            this.batchDialogVisible = true;
         })

         this.selectedBatch = null;
      },

      // 选择批号行
      selectBatch(row) {
         this.selectedBatch = row;
      },

      // 双击批号行直接确认选择
      confirmBatchSelection(row) {
         // 如果是双击事件，先设置选中的批号
         if (row) {
            this.selectedBatch = row;
         }

         // 检查所有批号的数量情况
         const batchesWithQuantity = this.batchList.filter(batch =>
            Number(batch.giftQuantity) && Number(batch.giftQuantity) > 0
         );

         // 如果没有任何批号设置数量，且双击了某个批号，则将该批号数量设为1
         if (batchesWithQuantity.length === 0 && this.selectedBatch) {
            console.log('🎁 双击批号，其他数量都是0，将当前批号数量设为1');
            this.$set(this.selectedBatch, 'giftQuantity', 1);
            
            // 重新筛选有数量的批号
            const updatedBatchesWithQuantity = this.batchList.filter(batch =>
               Number(batch.giftQuantity) && Number(batch.giftQuantity) > 0
            );
            
            if (updatedBatchesWithQuantity.length === 0) {
               this.$message.warning('设置数量失败，请重试');
               return;
            }
         } else if (batchesWithQuantity.length === 0) {
            this.$message.warning('请至少为一个批号设置数量');
            return;
         }

         // 重新获取有数量的批号列表（包含可能新设置的数量）
         const finalBatchesWithQuantity = this.batchList.filter(batch =>
            Number(batch.giftQuantity) && Number(batch.giftQuantity) > 0
         );

         // 为每个有数量的批号更新对应的赠品信息
         finalBatchesWithQuantity.forEach(batch => {
            if (this.currentBatchBgmId) {
               const giftRow = this.giftList.find(gift => gift.bgmId === this.currentBatchBgmId);
               if (giftRow) {
                  // 如果是第一个批号或者当前批号，直接更新
                  if (batch === finalBatchesWithQuantity[0] || batch === this.selectedBatch) {
                     this.$set(giftRow, 'batchno', batch.batchno || '');
                     this.$set(giftRow, 'expidate', batch.expidate || '');
                     this.$set(giftRow, 'prodate', batch.prodate || '');
                     this.$set(giftRow, 'bgiType', batch.bgiType || '');
                     this.$set(giftRow, 'num', batch.num || '');
                     this.$set(giftRow, 'price', batch.psprice || 0);
                     this.$set(giftRow, 'giftQuantity', Number(batch.giftQuantity));
                     this.$set(giftRow, 'quantity', Number(batch.giftQuantity));
                  }
               }
            }
         });

         console.log(this.batchList, 'this.batchList');
         console.log('填写数量大于0的批号条数:', finalBatchesWithQuantity.length);
         console.log('填写数量大于0的批号列表:', finalBatchesWithQuantity);

         this.closeBatchDialog();

         // 如果只有一个赠品，选完批号后自动确认并关闭弹窗
         if (this.giftList.length === 1 && finalBatchesWithQuantity.length === 1) {
            // 自动选中这个唯一的赠品
            this.selectedGiftId = this.giftList[0].bgmId;
            this.selectedGift = this.giftList[0];

            // 延迟一下确保数据更新完成，然后自动确认
            this.$nextTick(() => {
               this.confirmSelection();
            });
         } else {
            // 多个批号选择 - 直接使用已筛选的finalBatchesWithQuantity
            console.log('validBatches', finalBatchesWithQuantity);
            this.$nextTick(() => {
               this.confirmSelectionII(finalBatchesWithQuantity);
            });
         }
      },

      // 确认批号选择（原方法保持兼容）
      confirmBatchSelectionOriginal() {
         if (!this.selectedBatch) {
            this.$message.warning('请选择一个批号');
            return;
         }

         // 将批号直接赋值到对应的赠品行
         if (this.currentBatchBgmId) {
            const giftRow = this.giftList.find(gift => gift.bgmId === this.currentBatchBgmId);
            if (giftRow) {
               this.$set(giftRow, 'batchno', this.selectedBatch.batchno || '');
            }
         }

         this.closeBatchDialog();
      },

      // 关闭批号选择弹窗
      closeBatchDialog() {
         this.batchDialogVisible = false;
         this.selectedBatch = null;

         // 重新聚焦到赠品表格
         this.$nextTick(() => {
            if (this.$refs.giftTable && this.$refs.giftTable.$el) {
               this.$refs.giftTable.$el.focus();
            }
         });
      },

      // 格式化日期
      formatDate(timestamp) {
         if (!timestamp) return '-';
         const date = new Date(timestamp);
         return date.toLocaleDateString('zh-CN');
      },


      // 赠品弹窗打开后的处理
      onGiftDialogOpened() {
         this.$nextTick(() => {
            // 默认选中第一行
            if (this.giftList && this.giftList.length > 0) {
               // 设置当前行为第一行
               if (this.$refs.giftTable) {
                  this.$refs.giftTable.setCurrentRow(this.giftList[0]);
                  // 聚焦到表格，使其可以接收键盘事件
                  this.$refs.giftTable.$el.focus();
               }
            }
         });
      },

      // 初始化弹窗
      initDialog() {
         console.log("初始化赠品选择弹窗", this.giftInfo);

         this.giftList = this.giftInfo;
         this.inputBatchNo = '';
         // 自动选择第一个赠品（使用bgmId）
         if (this.giftList.length > 0) {
            this.selectedGiftId = this.giftList[0].bgmId;
            this.selectedGift = this.giftList[0];
         }
      },

      // 处理赠品选择变化
      onGiftSelectionChange(gift) {
         this.selectedGift = gift;
         console.log("🎁 选中的赠品:", gift);
      },

      // 点击行选择赠品
      selectGiftRow(row, column, event) {
         this.selectedGiftId = row.bgmId;
         this.selectedGift = row;
      },




      // 批号弹窗打开后的处理
      onBatchDialogOpened() {
         this.$nextTick(() => {
            // 设置表格可聚焦
            if (this.$refs.batchTable && this.$refs.batchTable.$el) {
               this.$refs.batchTable.$el.setAttribute('tabindex', '0');
               this.$refs.batchTable.$el.focus();
            }
            // 默认选中第一行
            if (this.batchList.length > 0) {
               this.currentRowIndex = 0;
               this.$refs.batchTable.setCurrentRow(this.batchList[0]);
            }
         });
      },

      // 处理赠品表格键盘事件
      handleGiftTableKeydown(event) {
         if (!this.giftList.length) return;

         switch (event.keyCode) {
            case 38: // 上箭头
               event.preventDefault();
               this.navigateGiftTable(-1);
               break;
            case 40: // 下箭头
               event.preventDefault();
               // 检查是否在最后一行，如果是则跳转到确定按钮
               const currentRow = this.$refs.giftTable.store.states.currentRow;
               const currentIndex = this.giftList.indexOf(currentRow);
               if (currentIndex === this.giftList.length - 1) {
                  // 聚焦到确定按钮
                  this.$refs.confirmButton.$el.focus();
               } else {
                  this.navigateGiftTable(1);
               }
               break;
            case 13: // 回车键
               event.preventDefault();
               // 选中当前高亮的行
               const selectedRow = this.$refs.giftTable.store.states.currentRow;
               if (selectedRow && selectedRow.bgmId) {
                  this.selectedGiftId = selectedRow.bgmId;
                  this.selectedGift = selectedRow;
                  this.onGiftSelectionChange(selectedRow);
                  this.openSearch(2938338304, selectedRow.bgmId);
               }
               break;
         }
      },

      // 处理确定按钮键盘事件
      handleConfirmButtonKeydown(event) {
         switch (event.keyCode) {
            case 38: // 上箭头
               event.preventDefault();
               // 返回到表格最后一行
               if (this.giftList.length > 0) {
                  this.$refs.giftTable.setCurrentRow(this.giftList[this.giftList.length - 1]);
                  this.$refs.giftTable.$el.focus();
               }
               break;
            case 13: // 回车键
               event.preventDefault();
               this.confirmSelection();
               break;
         }
      },

      // 导航赠品表格
      navigateGiftTable(direction) {
         const currentRow = this.$refs.giftTable.store.states.currentRow;
         const currentIndex = this.giftList.indexOf(currentRow);
         let newIndex = currentIndex + direction;

         // 边界检查
         if (newIndex < 0) {
            newIndex = this.giftList.length - 1;
         } else if (newIndex >= this.giftList.length) {
            newIndex = 0;
         }

         // 设置新的当前行
         this.$refs.giftTable.setCurrentRow(this.giftList[newIndex]);
      },

      // 导航批号表格
      navigateTable(direction) {
         const currentRowIndex = this.currentRowIndex || 0;
         let newIndex = currentRowIndex + direction;

         // 边界检查
         if (newIndex < 0) {
            newIndex = this.batchList.length - 1;
         } else if (newIndex >= this.batchList.length) {
            newIndex = 0;
         }

         // 更新当前行索引
         this.currentRowIndex = newIndex;
         // 设置新的当前行
         this.$refs.batchTable.setCurrentRow(this.batchList[newIndex]);
      },

      // 处理批号表格键盘事件
      handleTableKeydown(event) {
         if (!this.batchList.length) return;

         switch (event.keyCode) {
            case 38: // 上箭头
               event.preventDefault();
               this.navigateTable(-1);
               break;
            case 40: // 下箭头
               event.preventDefault();
               this.navigateTable(1);
               break;
            case 13: // 回车键
               event.preventDefault();
               this.confirmBatchSelection();
               break;
            case 27: // ESC键
               event.preventDefault();
               event.stopPropagation(); // 阻止事件冒泡到父级弹窗
               // 只关闭批号弹窗，不返回聚焦
               this.batchDialogVisible = false;
               this.selectedBatch = null;
               break;
         }
      },

      // 设置当前选中行
      setCurrentRow() {
         const currentRow = this.batchList[this.currentRowIndex];
         this.$refs.batchTable.setCurrentRow(currentRow);
         this.selectedBatch = currentRow;
      },

      // 处理表格行变化
      handleCurrentChange(currentRow) {
         if (currentRow) {
            this.selectedBatch = currentRow;
            this.currentRowIndex = this.batchList.findIndex(item => item === currentRow);
         }
      },

      // 确认选择
      confirmSelection() {
         // 校验是否选择了赠品
         if (!this.selectedGift) {
            this.$message.warning('请选择一个赠品');
            return;
         }

         console.log("🎁 选中的赠品990:", this.selectedGift);

         // 触发确认事件，传递选中的赠品（批号已直接赋值到赠品对象中）
         this.$emit('confirm', {
            gift: this.selectedGift
         });
         this.handleClose();
      },

      // 处理多个批号选择的确认方法
      confirmSelectionII(validBatches) {
         console.log("🎁 多个批号选择确认:", validBatches);
         
         if (!validBatches || validBatches.length === 0) {
            this.$message.warning('请至少选择一个有效的批号并设置数量');
            return;
         }
         
         // 触发多个批号确认事件，传递筛选后的有效批号数据
         this.$emit('confirmII', {
            gifts: validBatches
         });
         
         this.handleClose();
      },

      // 关闭弹窗
      handleClose() {
         this.dialogVisible = false;
         this.$emit('close');
      }
   }
};
</script>

<style scoped>
.gift-list-section {
   margin-bottom: 20px;
}

.gift-list-section h4 {
   margin-bottom: 10px;
   color: #333;
}

.dialog-footer {
   text-align: right;
}
</style>
